import React, { useEffect, useRef, useState } from "react";
import { FiSearch, FiX, FiLoader } from "react-icons/fi";
import useServerUserSearch from "../../hooks/useServerUserSearch";
import UserAvatar from "../common/UserAvatar/UserAvatar";
import s from "./SzufladaDysku.module.css";

/* ════════════════════════════════════════════════════════════════════════════════════════
   WyborOsoby — WYBÓR OSOBY Z APLIKACJI, nie wolne pole tekstowe.

   [polecenie właściciela 2026-09-12] „przypilnowania właściciela (…) Wybór właściciela-osoby
   przez WYSZUKIWANIE osoby w aplikacji (nie wolne pole tekstowe)."

   ── CO BYŁO ŹLE ──────────────────────────────────────────────────────────────────────────
   Stara szuflada miała podpowiedzi, ale pole zostawało zwykłym `<input type="text">`: wpisany
   napis NIE musiał odpowiadać żadnemu kontu. Wybranie osoby z listy ustawiało `ownerUserId`,
   ale późniejsza EDYCJA napisu w polu już go nie zdejmowała — dało się więc zapisać zasób,
   którego właściciel nazywa się „Kowalski", a `ownerUserId` wskazuje na kogoś zupełnie innego.
   Tutaj wybrana osoba zamienia pole na PLAKIETKĘ z krzyżykiem: żeby wpisać coś innego, trzeba
   najpierw jawnie zdjąć wybór — a wtedy identyfikator również znika.
   ════════════════════════════════════════════════════════════════════════════════════════ */

const pelneImie = (osoba) =>
    osoba ? `${osoba.firstName || ""} ${osoba.lastName || ""}`.trim() || osoba.email || "" : "";

const WyborOsoby = ({
    wybrana,
    onWybierz,
    aktywne = true,
    placeholder = "Szukaj pracownika...",
    bledny = false,
    idPola,
    idOpisu,
}) => {
    const [fraza, setFraza] = useState("");
    const [otwarta, setOtwarta] = useState(false);
    const obszarRef = useRef(null);

    const { users, loading } = useServerUserSearch({
        enabled: aktywne && otwarta && !wybrana,
        query: fraza,
        limit: 8,
    });

    // Klik poza obszarem zamyka listę podpowiedzi (sama lista, nie okno).
    useEffect(() => {
        const pozaObszarem = (e) => {
            if (obszarRef.current && !obszarRef.current.contains(e.target)) setOtwarta(false);
        };
        document.addEventListener("mousedown", pozaObszarem);
        return () => document.removeEventListener("mousedown", pozaObszarem);
    }, []);

    if (wybrana) {
        return (
            <div className={s.kartaWlasciciela}>
                <div className={s.kartaAwatar}>
                    <UserAvatar userId={wybrana.id} displayName={pelneImie(wybrana)} wypelnij dekoracyjny
                        inicjaly={(pelneImie(wybrana)[0] || "?").toUpperCase()} />
                </div>
                <div className={s.kartaTresc}>
                    <div className={s.kartaNazwa}>{pelneImie(wybrana)}</div>
                    <div className={s.kartaOpis}>{wybrana.email}</div>
                </div>
                <button
                    type="button"
                    className={s.usun}
                    onClick={() => {
                        onWybierz(null);
                        setFraza("");
                    }}
                    title="Zdejmij wybór osoby"
                    aria-label="Zdejmij wybór osoby"
                >
                    <FiX size={14} />
                </button>
            </div>
        );
    }

    return (
        <div className={s.szukajkaOsoby} ref={obszarRef}>
            <input
                id={idPola}
                type="text"
                className={`${s.wejscie} ${bledny ? s.wejscieBledne : ""}`}
                value={fraza}
                onChange={(e) => {
                    setFraza(e.target.value);
                    setOtwarta(true);
                }}
                onFocus={() => setOtwarta(true)}
                placeholder={placeholder}
                autoComplete="off"
                aria-invalid={bledny ? "true" : undefined}
                aria-describedby={idOpisu}
            />
            {otwarta && (
                <div className={s.lista}>
                    {loading && (
                        <div className={s.listaPusta}>
                            <FiLoader className={s.obrot} size={12} /> Szukam...
                        </div>
                    )}
                    {!loading && users.length === 0 && (
                        <div className={s.listaPusta}>
                            <FiSearch size={12} /> Brak pracowników pasujących do frazy.
                        </div>
                    )}
                    {users.map((u) => (
                        <button
                            type="button"
                            key={u.id}
                            className={s.listaPozycja}
                            onClick={() => {
                                onWybierz(u);
                                setOtwarta(false);
                                setFraza("");
                            }}
                        >
                            <span className={s.listaNazwa}>{pelneImie(u)}</span>
                            <span className={s.listaEmail}>{u.email}</span>
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};

export default WyborOsoby;
